// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 236 ? "9cb7a7c1" : chunkId) + "." + {"236":"d6224f9342183121","726":"f898ec51164c44ad"}[chunkId] + ".js";
};